<div style="margin: 10px;">
	<form [formGroup]="SettingsForm">
		<legend>Include Devices</legend>
		<div class="mb-3 row">
			<div class="col-lg-6" [ngClass]="{'has-error':!IncludeScope.valid}">
				<label>Include IP Addresses / IP Ranges</label>
				<textarea rows="8" cols="50" class="form-control" [formControl]="IncludeScope"></textarea>
			</div>
			<div class="col-lg-3">
				<label>Include Categories ({{IncludeCategories.length}} selected)</label>
				<device-category-selector [(selection)]="IncludeCategories" scrollHeight="145px"
										  (selectionChange)="onIncludeCategoriesChange($event)">
				</device-category-selector>
			</div>
		</div>
		<legend>Exclude Devices</legend>
		<div class="mb-3 row">
			<div class="col-lg-6" [ngClass]="{'has-error':!ExcludeScope.valid}">
				<label>Exclude IP Addresses / IP Ranges</label>
				<textarea rows="8" cols="50" class="form-control" [formControl]="ExcludeScope"></textarea>
			</div>
			<div class="col-lg-3">
				<label>Exclude Categories ({{ExcludeCategories.length}} selected)</label>
				<device-category-selector [(selection)]="ExcludeCategories" scrollHeight="145px"
										  (selectionChange)="onExcludeCategoriesChange($event)">
				</device-category-selector>
			</div>
		</div>
	</form>
</div>
